import Vue from "vue";
import axios from "axios";

const vm = Vue.prototype;
const QABUL_BASE = process.env.VUE_APP_QABUL_API || "/qabul/api/v1/";

const examApi = axios.create({
  baseURL: QABUL_BASE,
  timeout: 30000,
});

examApi.interceptors.request.use((config) => {
  const token = vm.$cookies.get("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default examApi;
